/**
 * Discriminates between Maily (Tiptap/ProseMirror) JSON and Unlayer JSON.
 *
 * Both editors share the same `design_json` JSONB column on the backend
 * (see boompay-api PR #3828). Tiptap documents always have `type: "doc"`
 * at the root; Unlayer documents have `body.rows`. This check is enough
 * to route the saved blob into the correct editor on load.
 */
export function isMailyJson(value: unknown): boolean {
  if (typeof value !== "object" || value === null) return false;
  const v = value as { type?: unknown };
  return v.type === "doc";
}
